import { render, staticRenderFns } from "./editServer.vue?vue&type=template&id=1751d152&"
import script from "./editServer.vue?vue&type=script&lang=js&"
export * from "./editServer.vue?vue&type=script&lang=js&"
import style0 from "./editServer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports